export default {
  gridcontextmenu: {
    gridContextMenuModal: {
      header: "View",
      menu: {
        full: "Full",
        optimal: "Optimal",
        load: "Load my settings",
        save: "Save my settings"
      },
      stateApplied: {
        loadSuccess: "Settings loaded successfully",
        saveSuccess: "Settings saved successfully",
        loadError: "No settings saved"
      }
    }
  }
};
